import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { ItemsListRowItemBase } from '@fi-app/components/items-list/list-row/list-row-item/list-row-item-base';
import { CustomerBillingCustomerModel } from '../customer-billing-customer.model';
import { CustomerBillingInvoiceModel } from '../../customer-billing-invoice/customer-billing-invoice.model';
import { InvoiceType } from '../../customer-billing-invoice/invoice-type';
import { InvoiceService } from '../../customer-billing-invoice/invoice.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { CustomerService } from '../customer.service';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { fiCustomerPaymentStatus } from '../customer-payment-status';
import { CustomerBillingInvoiceCreateDialogComponent } from '../../customer-billing-invoice/customer-billing-invoice-create-dialog/customer-billing-invoice-create-dialog.component';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { CurrencyType } from '@fi-app/customer-billing/customer-billing-price/currency-type';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { InvoicesListItemBase } from '@fi-app/customer-billing/customer-billing-customer/invoices-list-item-base';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-monthly-invoices-list-item',
    templateUrl: './monthly-invoices-list-item.component.html',
    styleUrls: ['./monthly-invoices-list-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-monthly-invoices-list-item' },
    standalone: false,
})
export class MonthlyInvoicesListItemComponent extends InvoicesListItemBase {
    private ownerBillingInfo: CustomerBillingCustomerModel = undefined;
    private appTextService: AppTextService;
    private fiFormatDateService: FiFormatDateService;

    constructor(injector: Injector) {
        super(injector);

        this.appTextService = injector.get(AppTextService);
        this.fiFormatDateService = injector.get(FiFormatDateService);
    }

    isMonthlyInvoiceCreated(customer: CustomerBillingCustomerModel) {
        return customer.CurrentMonthlyInvoice;
    }

    isMonthlyInvoiceSent(customer: CustomerBillingCustomerModel) {
        return this.isMonthlyInvoiceCreated(customer) && !!customer.CurrentMonthlyInvoice.SentDates.length;
    }

    isMonthlyInvoicePaid(customer: CustomerBillingCustomerModel) {
        return this.isMonthlyInvoiceSent(customer) && customer.CurrentMonthlyInvoice.PaidDate;
    }

    private showInvoiceDialog(customer: CustomerBillingCustomerModel) {
        const currencyType = customer && customer.InvoiceInfo ? customer.InvoiceInfo.Currency : CurrencyType.SEK;
        const invoice = new CustomerBillingInvoiceModel({
            InvoiceType: InvoiceType.Monthly,
            CurrencyType: currencyType,
        });

        invoice.setOwnerInformation(this.ownerBillingInfo);

        invoice.setCustomerInformation(customer);

        const promise = this.invoiceService
            .GetMonthlyInvoicePredefinedArticles(customer.BillingCustomerId)
            .then((articles) => {
                invoice.setupInitialMonthlyArticles(articles, this.appTextService, this.fiFormatDateService);
                this.fiDialogsService
                    .custom({
                        hideHeader: true,
                        hideFooter: true,
                        contentComponentRef: CustomerBillingInvoiceCreateDialogComponent,
                        contentComponentData: invoice,
                        config: {
                            panelClass: 'fi-customer-billing-invoice-panel',
                            minWidth: '70%',
                            maxWidth: '70%',
                            minHeight: '90%',
                            maxHeight: '90%',
                        },
                    })
                    .onYesButtonClick(() => {
                        customer.CurrentMonthlyInvoice = invoice;
                        this.cdr.markForCheck();
                    });
            });

        this.fiLoadingService.trackPromise(promise);
    }

    createMonthlyInvoice($event: MouseEvent, customer: CustomerBillingCustomerModel) {
        $event.stopPropagation();

        if (customer.PaymentStatus == fiCustomerPaymentStatus.Freemium) return;

        if (!this.ownerBillingInfo) {
            const promise = this.customerService.GetCustomer(this.customerDataService.customerData.CustomerId);

            this.fiLoadingService.trackPromise(promise);

            promise.then((response) => {
                this.ownerBillingInfo = response;
                this.showInvoiceDialog(customer);
            });
        } else this.showInvoiceDialog(customer);
    }

    isAddInvoiceAvailable(customer) {
        return this.customerBillingWriteAccess && customer.PaymentStatus == fiCustomerPaymentStatus.Paying;
    }

    onInvoiceInfoClick($event: MouseEvent, customer: CustomerBillingCustomerModel) {
        $event.stopPropagation();
        this.fiStateService.go(FiStateNames.CustomerBilling.Invoice.View, { Id: customer.CurrentMonthlyInvoice.Id });
    }
}
